import React from 'react';
import PropTypes from 'prop-types';
import {Paper, withStyles} from '@material-ui/core';
import {MainContentStyles} from 'assets/tss/layouts/admin';
import {InferPropTypes} from 'commons/types/Types';

/**
 * Main Content container
 * @param props Styles & Prop Types. Todo: Infer Props
 * @constructor
 */
function MainContent(
    props: InferPropTypes<
        typeof MainContent.propTypes,
        typeof MainContentStyles
    >
) {
    const {classes, children} = props;
    return (
        <Paper elevation={0} square className={classes.root}>
            {children || 'Main Content'}
        </Paper>
    );
}

MainContent.propTypes = {
    children: PropTypes.node.isRequired,
};

export default withStyles(MainContentStyles)(MainContent);
